// Capa de acceso a datos para la feature de Interoperabilidad.

import { api } from '../../../api/client';

const BASE = '/interop';

// Catálogo de conectores

/** Obtiene todos los conectores registrados. */
const search = (dataSearch={}) => api.post(`${BASE}/services/search`,dataSearch);

/** Crea o actualiza un conector.
 * @param {InteropServiceDto} dto */
const saveService = (dto) => api.post(`${BASE}/services`, dto);

/** Elimina un conector por código. */
const deleteService = (code) =>
  api.delete(`${BASE}/services/${encodeURIComponent(code)}`);

/** Cambia el estado manual (interruptor) de un conector.
 * @param {string} code
 * @param {'Conectado'|'Mantenimiento'|'Desconectado'} status */
const updateStatus = (code, status) =>
  api.patch(
    `${BASE}/services/${encodeURIComponent(code)}/status?status=${encodeURIComponent(status)}`
  );

/** Health check real (prueba conectividad y persiste resultado). */
const healthCheck = (code) =>
  api.post(`${BASE}/services/${encodeURIComponent(code)}/health-check`);

/** Sincroniza (health check simple) un conector individual. */
const syncService = (code) =>
  api.post(`${BASE}/services/${encodeURIComponent(code)}/sync`);

/** Escanea todos los conectores en paralelo vía Apache Camel. */
const scanAll = () => api.post(`${BASE}/services/scan-all`);

// Matriz de campos

/** Obtiene los field-mappings de un conector. */
const getFieldMappings = (code) =>
  api.get(`${BASE}/services/${encodeURIComponent(code)}/field-mappings`);

/** Guarda field-mappings de un conector. */
const saveFieldMappings = (code, mappings) =>
  api.put(`${BASE}/services/${encodeURIComponent(code)}/field-mappings`, mappings);

/** Auto-detecta campos desde un payload de ejemplo. */
const autoDetectFields = (code, sampleResponse) =>
  api.post(`${BASE}/services/${encodeURIComponent(code)}/field-mappings/auto-detect`, sampleResponse);

// Consultas

/** Ejecuta una consulta hacia un sistema externo.
 * @param {{ targetSystem: string, action: string, payload: object, subjectKey?: string }} queryData */
const executeQuery = (queryData) => api.post(`${BASE}/query`, queryData);

// Historial, métricas y exportación 

/** Historial de peticiones de integración. */
const getLog = (searchData) => api.post(`${BASE}/log/search`,searchData);

/** Métricas agregadas del hub. */
const getMetrics = () => api.get(`${BASE}/metrics`);

/** Estado general del hub. */
const getStatus = () => api.get(`${BASE}/status`);

/**
 * Exporta el historial en CSV y dispara la descarga en el navegador.
 * El back devuelve text/csv, así que usamos fetch raw + Blob.
 */
const exportLogCsv = async () => {
  const blob = await api.getBlob(`${BASE}/export/log`);
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `reporte_interoperabilidad_${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

/** Prueba la conexión y extrae todos los campos disponibles de la colección.
 * @param {string} code
 * @param {object} [overrideParams] */
const testConnection = (code, overrideParams = {}) =>
  api.post(`${BASE}/services/${encodeURIComponent(code)}/test-connection`, overrideParams);

/** Analiza e introspecciona un payload JSON/XML arbitrario. */
const inspectPayload = (code, payload) =>
  api.post(`${BASE}/services/${encodeURIComponent(code)}/inspect-payload`, payload);

/** Obtiene el catálogo consolidado de campos listos para XSD y certificados. */
const getFieldsCatalog = () => api.get(`${BASE}/services/fields-catalog`);

/** Obtiene los campos para XSD de un conector específico. */
const getServiceFieldsCatalog = (code) =>
  api.get(`${BASE}/services/${encodeURIComponent(code)}/fields-catalog`);

export const interoperabilityApi = {
   search,
  saveService,
  deleteService,
  updateStatus,
  healthCheck,
  syncService,
  scanAll,
  testConnection,
  inspectPayload,
  getFieldMappings,
  saveFieldMappings,
  autoDetectFields,
  getFieldsCatalog,
  getServiceFieldsCatalog,
  executeQuery,
  getLog,
  getMetrics,
  getStatus,
  exportLogCsv,
};
